import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { CuentaContable } from '../../../models/cuenta-contable';
import { TipoCuenta } from '../../../models/tipo-cuenta';
import { CuentaContableService } from '../../../services/cuenta-contable.service';
import { SessionService } from '../../../services/session.service';

@Component({
  selector: 'app-plan-cuentas-add-modal',
  templateUrl: './plan-cuentas-add-modal.component.html',
  styleUrls: ['./plan-cuentas-add-modal.component.css'],
  providers: [
    CuentaContableService,
    SessionService,
  ],
})
export class PlanCuentasAddModalComponent implements OnInit {
  @Input() tipoCuenta: TipoCuenta;
  @Output() sendCuenta = new EventEmitter();
  public cuentaContable: CuentaContable;
  public loading: boolean;
  public msgSweet: SweetMessage;
  public cuentaPadre: CuentaContable;
  public cuentasPadre: Array<CuentaContable>;
  public cuentaP: CuentaContable;
  constructor(
    public bsModalRef: BsModalRef,
    public cuentaContableService: CuentaContableService,
    private ss: SessionService,
  ) { 
    this.loading = false;
    this.msgSweet = new SweetMessage();
    this.cuentaContable = new CuentaContable();
    this.cuentaP = null;
    this.cuentaPadre = new CuentaContable();
    this.cuentasPadre = [];
  }

  ngOnInit() {
    this.getCuentasPadre();
  }

  getCuentasPadre(){
    return new Promise((resolve, reject)=>{
      let qs = "?in[nivel_cuenta_id]=1,2,3&status=A&tipo_cuenta_id=" + this.tipoCuenta.id;
      this.cuentaContableService.getAll(qs).subscribe(
        res =>{
          this.cuentasPadre = res.data;
          resolve();
        },
        err =>{
          reject();
        });
    });
  }

  onChangeCuentaPadre(){
    this.cuentaPadre = this.cuentaP;
  }

  isValid(){
    if(this.cuentaContable.nombre == ""){
      return false;
    }
    return true;
  }

  setValueEntity(){
    this.cuentaContable.nombre = this.cuentaContable.nombre.trim();
    this.cuentaContable.descripcion = this.cuentaContable.descripcion.trim();
    this.cuentaContable.tipo_cuenta_id = this.tipoCuenta.id;
    this.cuentaContable.isPadre = false;
    this.cuentaContable.status = "A";
    if(this.cuentaP){
      this.cuentaContable.codigo = this.cuentaPadre.codigo;
      this.cuentaContable.padre_id = this.cuentaPadre.id;
      this.cuentaContable.nivel_cuenta_id  = (Number(this.cuentaPadre.nivel_cuenta_id) + 1).toString();
    }else{
      this.cuentaContable.codigo = this.tipoCuenta.id;
      this.cuentaContable.nivel_cuenta_id = "1";
    }
    this.cuentaContable.usuario_id = this.ss.getData('usuario_id');
    this.cuentaContable.empresa_id = this.ss.getData('empresa_id');
  }

  onSubmit(){
    this.loading = true;
    this.setValueEntity();
		this.cuentaContableService.save(this.cuentaContable).subscribe(
			res => {
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
        this.loading = false;
        this.cuentaP = null;
        this.cuentaContable = new CuentaContable();
        this.cuentaPadre = new CuentaContable();
        this.getCuentasPadre();
        this.sendCuenta.emit(res.data);
			},
			err => {
        this.loading = false;
        this.cuentaContable = new CuentaContable();
        this.cuentaPadre = new CuentaContable();
        this.cuentaP = null;
        this.msgSweet.showMessage('error-message',err);
			}
		);
  }
  

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/plan-cuentas-add-modal/plan-cuentas-add-modal.component.ts